/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespAppliedFilters_viewer = {
    readonly isSbSharedRefineMenuSearchWithinEnabled: boolean | null;
    readonly " $refType": "SbRespAppliedFilters_viewer";
};
export type SbRespAppliedFilters_viewer$data = SbRespAppliedFilters_viewer;
export type SbRespAppliedFilters_viewer$key = {
    readonly " $data"?: SbRespAppliedFilters_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespAppliedFilters_viewer",
  "selections": [
    {
      "alias": "isSbSharedRefineMenuSearchWithinEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '4ab392daf31c3e86596e9286149bd0a5';
export default node;
